/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import {
  Flex,
  lightTheme,
  ProgressCircle,
  Provider
} from '@adobe/react-spectrum'
import React, { createContext, useState } from 'react'
import { UixContextProps } from './props/UixContextProps'

export const UixContext = createContext<UixContextProps>({
  isConnected: false
})

export function UixContainer(props: React.PropsWithChildren) {
  const [isConnected, setConnected] = useState(false)

  return (
    <>
      <UixContext.Provider value={{ isConnected, setConnected }}>
        {!isConnected && (
          <Provider theme={lightTheme} colorScheme={'light'}>
            <Flex alignItems='center' justifyContent='center' height='100vh'>
              <ProgressCircle size='L' aria-label='Loading…' isIndeterminate />
            </Flex>
          </Provider>
        )}
        {props.children}
      </UixContext.Provider>
    </>
  )
}
